export default __webpack_public_path__ + "static/media/icon-coin-chz.1c483272.svg";